import React from "react";
import { translate } from "lib";
import { ErrorBoundary } from "components/Shared";
import Actor from "components/Activities/Actor"
import Context from "components/Activities/Context"
import ItemObject from "components/Activities/ItemObject"

const AcceptTask = ({ activity }: { activity: tcpinpoint.ActivityItem }) => <ErrorBoundary>
    {<Actor actor={activity.attributes.item.actor} />}{' '}
    {translate('closed')}{' '}
    <ItemObject object={activity.attributes.item.object} />{" "}
    <Context context={activity.attributes.item.context} />
</ErrorBoundary>

export default AcceptTask;